import axios from '@/configs/axios'
import {
  ILicenseActionResult,
  ILicensePoint,
  ILicenseSituation,
  LicensePointStatus,
} from '@/models/license'
import { IProcess } from '@/models/process'
import { PaginationDTO } from '@/models/table'

const baseUrl = () => `${process.env.VUE_APP_API_URL}/licenca`

export const getSituation = () => axios.get<ILicenseSituation>(baseUrl())

export const getPoints = (
  page: PaginationDTO<ILicensePoint>,
  filter: { status?: LicensePointStatus | null; serial?: string },
) =>
  axios.get<PaginationDTO<ILicensePoint>>(`${baseUrl()}/pontos`, {
    params: {
      page: page?.page,
      pageSize: page?.pageSize,
      status: filter?.status || undefined,
      serial: filter?.serial || undefined,
    },
  })

/** Só a role Nepen. */
export const updateTotal = (totalPontos: number) =>
  axios.put<ILicenseSituation>(`${baseUrl()}/total`, { totalPontos })

/** Só a role Nepen. Liga ou desliga o contrato por pontos do cliente corrente. */
export const setActive = (ativa: boolean) =>
  axios.put<ILicenseSituation>(`${baseUrl()}/ativa`, { ativa })

export const removePoint = (serial: string) =>
  axios.post<ILicenseActionResult>(`${baseUrl()}/pontos/${encodeURIComponent(serial)}/remover`)

export const restorePoint = (serial: string) =>
  axios.post<ILicenseActionResult>(`${baseUrl()}/pontos/${encodeURIComponent(serial)}/restaurar`)

/** Envia o próprio arquivo: o backend lê a coluna serial e cria um processo com um ticket por medidor. */
export const removePointsByFile = (file: File) => {
  const form = new FormData()
  form.append('file', file)
  return axios.post<IProcess>(`${baseUrl()}/pontos/remover-arquivo`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}
